const $ = jQuery.noConflict();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		$('body').on('click', '.video-link', function (event) {
			event.preventDefault();
			const acfBlock = $(this).closest('.acf-block');
			const src = $(this).data('video-src');
			const framSrc = $(this).closest('.container').find('.video-frame__iframe-embed');
			framSrc.attr('src', src);
			const videoWrapper = $(this).closest('.container').find('.video-popup__wrapper');
			if (!videoWrapper.hasClass('active')) {
				const iframe = $(
					'.video-popup__wrapper .video-frame__iframe-embed'
				);
				iframe[0].src += '?autoplay=1';
				videoWrapper.addClass('active');
				videoWrapper.show();
				acfBlock.addClass('video-active');
				$('body').addClass('lock-scroll');
			}
		});
		$('body').on('click', '.video-popup__close', function () {
			const acfBlock = $(this).closest('.acf-block');
			const videoWrapper = $(this).closest('.video-popup__wrapper');
			if (videoWrapper.hasClass('active')) {
				const iframe = $(
					'.video-popup__wrapper .video-frame__iframe-embed'
				);
				iframe.attr('src', '');
				videoWrapper.removeClass('active');
				videoWrapper.hide();
				acfBlock.removeClass('video-active');
				$('body').removeClass('lock-scroll');
			}
		});
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
